import * as React from "react";

export const Paragraph = ({ text, type = '' }) => {
    if (typeof text === 'string') {
        return <p className={type} dangerouslySetInnerHTML={{__html: text.replace(/\n/g, '<br />')}} />;
    } else {
        return <p className={type}>{text}</p>;
    }
};

export default Paragraph;